import _ from 'lodash';

import {
  getMortgageFreeCreditScore,
  getMortgageStateFreeCreditScore,
  getMortgagePaymentFreeCreditScore,
  getMortgageAmortizationFreeCreditScore,
} from '../../../lib/analytics-constants';

import {
  ToolLinkCard as ToolLinkCardType,
  Data,
  AnalyticsConfig,
  CardLink,
  CalculatorType,
} from './types';

interface CardLinkProps extends CardLink {
  keys?: { key: string }[];
}

interface ImpressionPayloadProps {
  impressionEventPayload?: any;
  analyticsConfig: AnalyticsConfig;
  calculatorType?: CalculatorType;
}

export const getMCEventPayload = (
  calculatorType: CalculatorType,
  defaultPayload?: any
): any => {
  switch (calculatorType) {
    case 'mortgage_state_calculator':
      return getMortgageStateFreeCreditScore();
    case 'mortgage_calculator':
      return getMortgageFreeCreditScore();
    case 'mortgage_payment_calculator':
      return getMortgagePaymentFreeCreditScore();
    case 'mortgage_amortization_calculator':
      return getMortgageAmortizationFreeCreditScore();
    case 'rent_vs_buy_calculator':
      // The payload in this scenario is already calculated and we don't want to override it.
      return defaultPayload;
    default:
      return null;
  }
};

export const getImpressionPayload = ({
  impressionEventPayload,
  analyticsConfig,
  calculatorType,
}: ImpressionPayloadProps): any => {
  let impressionPayload = null;
  if (impressionEventPayload) {
    impressionPayload =
      typeof impressionEventPayload === 'function'
        ? impressionEventPayload(analyticsConfig)
        : impressionEventPayload;
  }
  if (calculatorType) {
    impressionPayload = getMCEventPayload(calculatorType, impressionPayload);
  }
  return impressionPayload;
};

export const getLinkProps = (
  card: ToolLinkCardType,
  data: Data
): CardLinkProps => {
  const { link, keys } = card;
  if (link.url && keys) {
    let { url } = link;
    keys.forEach(({ key }, index) => {
      const formattedValue = _.get(data, key, '');
      url = url.replace(`{{${index}}}`, formattedValue);
    });
    return { keys, ...link, url };
  }
  return link;
};
